import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

// components
import ImagePreview from '@aytm/app/stats/components/image-preview/ImagePreview'
// import ImagePreview from '@aytm/app/survey/editor/components/content/assets/ImagePreview'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

// styles
import style from '@aytm/app/stats/page/question-views/im/styles/Block.module.scss'

const Block = ({ id, link, image, answer, isSurveyGuest, isReportXpert }) => {
  return (
    <BlockWrapper {...{ id, link, answer, isSurveyGuest, isReportXpert }}>
      <div className={style.image}>
        {undefined != image && undefined != image.original ? (
          <ImagePreview
            className={style['image-box']}
            minWidth="50px"
            maxWidth="600px"
            minHeight="50px"
            maxHeight="600px"
            imageUrl={image.original.url}
            previewUrl={getImageAssetPath({
              path: image.original.path,
              width: 600,
              height: 600,
              filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
              backgroundColor: 'white'
            })}
            allowScrolling={image.scrolling}
          />
        ) : null}
      </div>
    </BlockWrapper>
  )
}

Block.displayName = 'Block'

Block.propTypes = {
  id: PropTypes.string,
  answer: answerPropType,
  link: PropTypes.string,
  image: PropTypes.object,
  isReportXpert: PropTypes.bool,
  isSurveyGuest: PropTypes.bool
}

export default Block
